import TurtleInfoBar from './TurtleInfoBar';

export default TurtleInfoBar;
